<template>
  <USlideover
    v-model="active"
    :ui="{
      width: 'w-screen max-w-xs'
    }"
  >
    <div class="h-full flex flex-col">
      <div class="flex items-center justify-between border-b p-4">
        <h3 class="font-semibold text-center text-secondary">
          {{ businessName }}
        </h3>

        <button class="bg-transparent" @click="active = false">
          <b-icon icon="x" />
        </button>
      </div>

      <div class="flex flex-col justify-between flex-grow">
        <div class="flex-grow flex-shrink h-10">
          <div class="h-full overflow-y-auto">
            <ul class="flex flex-col px-2 py-3">
              <template v-if="menu">
                <li v-for="item in menu" :key="`${item.id}-${item.type}`">
                  <template v-if="item.type === 'group'">
                    <LayoutElementsMenuGroup :item="item" />
                  </template>

                  <template v-else>
                    <LayoutElementsMenuItem :item="item" />
                  </template>
                </li>
              </template>

              <!-- Has Default (Auto) Menu -->
              <template v-else>
                <li v-for="tab in tabs" :key="tab">
                  <LayoutElementsMenuItem
                    v-if="$site.tabs[tab]"
                    :item="{
                      id: tab,
                      name: $site.tabs.getName(tab, tab),
                      information: $site.tabs.getInfo(tab)
                    }"
                  />
                </li>

                <template v-if="$site.customPages">
                  <li v-for="page in $site.customPages" :key="page.id">
                    <LayoutElementsMenuItem
                      :item="{
                        id: page.id,
                        name: page.menuTitle,
                        information: page.info,
                        type: 'custom',
                        icon: page.icon,
                        slug: page.slug
                      }"
                    />
                  </li>
                </template>
              </template>
            </ul>
          </div>
        </div>
        
        <ul v-if="$site.tabs.user && (!isAppLayout || isLoggedIn)" class="flex flex-col border-t px-4 py-3">
          <li>
            <LayoutElementsMenuItem
              :item="{ id: 'user', name: userTabName }"
            />
          </li>
        </ul>
      </div>
    </div>
  </USlideover>
</template>

<script setup lang="ts">
const { $site, $auth } = useNuxtApp()
const layoutStore = useLayoutStore()
const route = useRoute()

const tabs = ref([
  'book',
  'timetable',
  'lastMinute',
  'giftCard',
  'pass',
  'gallery',
  'review'
])

const menu = computed(() => {
  if ($site.menu?.primary) { // $site.menu.primary is MenuItem[]
    const primary = $site.menu?.primary || []
    const secondary = $site.menu?.secondary || []

    return [
      ...primary,
      ...secondary
    ]
  }
})

const businessName = computed(() => {
  if ($site.tabs.contact && $site.tabs.contact.business) {
    return $site.tabs.contact.business
  } else {
    return $site.location.title
  }
})

const userTabName = computed(() => {
  if ($auth.isLoggedIn.value && $auth.user.value) {
    return $auth?.user.value.displayName
  } else {
    return $site.tabs.getName('user', 'Customer')
  }
})


const active = computed({
  get () {
    return layoutStore.menu
  },
  set (val) {
    layoutStore.menu = val
  }
})

const isLoggedIn = computed(() => {
  return $auth.isLoggedIn.value
})

const isAppLayout = computed(() => {
  return layoutStore.layout === 'app'
})

watch(() => route.path, () => {
  active.value = false
})
</script>

<style>
.slide-enter-active,
.slide-leave-active {
  transition: all .5s;
}

.slide-enter {
  transform: translateX(100%);
}

.slide-leave-to {
   transform: translateX(100%);
}

.fade-enter-active,
.fade-leave-active {
  transition: all .5s;
}

.fade-enter {
  opacity: 0;
}

.fade-leave-to {
   opacity: 0;
}

</style>
